import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = {
  key: 0,
  class: "offcanvas-footer"
}

import { useAppointmentDetail } from "@/composables/useAppointments";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useSessionStore } from "@/store/useSessionStore";
import { computed } from "vue";
import Actions from "./Actions.vue";
import BoletoPayment from "./BoletoPayment.vue";
import CallLink from "./CallLink.vue";
import Cancellation from "./Cancellation.vue";
import Info from "./Info.vue";
import PaymentError from "./PaymentError.vue";
import Profile from "./Profile.vue";
import Rating from "./Rating.vue";
import Receipt from "./Receipt.vue";
import Recommendations from "./Recommendations.vue";
import Recurrency from "./Recurrency.vue";
import RescheduleRequest from "./RescheduleRequest.vue";
import Values from "./Values.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentDetail',
  setup(__props) {

const offcanvasStore = useOffcanvasStore();
const sessionStore = useSessionStore();
const detailId = computed(
  () => offcanvasStore.config?.detail_id as number | undefined,
);

const { data: appointment, isPending } = useAppointmentDetail(detailId);

const myRating = computed(() => {
  const appt = appointment.value;
  if (!appt || appt.status !== "concluido" || !appt.ratings?.length)
    return null;
  const sessionId = sessionStore.session?.id;
  const found = appt.ratings.find((r) => r.user_id === sessionId);
  return found?.rating != null ? found : null;
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isPending))
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_unref(appointment))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(Profile, {
                user: _unref(appointment).user,
                chat: _unref(appointment).chat
              }, null, 8, ["user", "chat"]),
              (_unref(appointment).is_waiting_boleto_payment)
                ? (_openBlock(), _createBlock(BoletoPayment, { key: 0 }))
                : _createCommentVNode("", true),
              (_unref(appointment).paymentError)
                ? (_openBlock(), _createBlock(PaymentError, { key: 1 }))
                : _createCommentVNode("", true),
              (_unref(appointment).rescheduleRequest)
                ? (_openBlock(), _createBlock(RescheduleRequest, {
                    key: 2,
                    request: _unref(appointment).rescheduleRequest
                  }, null, 8, ["request"]))
                : _createCommentVNode("", true),
              _createVNode(Info, { item: _unref(appointment) }, null, 8, ["item"]),
              (myRating.value)
                ? (_openBlock(), _createBlock(Rating, {
                    key: 3,
                    rating: myRating.value
                  }, null, 8, ["rating"]))
                : _createCommentVNode("", true),
              (_unref(appointment).recurrency)
                ? (_openBlock(), _createBlock(Recurrency, {
                    key: 4,
                    recurrency: _unref(appointment).recurrency
                  }, null, 8, ["recurrency"]))
                : _createCommentVNode("", true),
              _createVNode(Values, { item: _unref(appointment) }, null, 8, ["item"]),
              (_unref(appointment).status === 'concluido')
                ? (_openBlock(), _createBlock(Receipt, {
                    key: 5,
                    item: _unref(appointment)
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (_unref(appointment).call_link)
                ? (_openBlock(), _createBlock(CallLink, {
                    key: 6,
                    callLink: _unref(appointment).call_link
                  }, null, 8, ["callLink"]))
                : _createCommentVNode("", true),
              _createVNode(Recommendations),
              _createVNode(Cancellation, { item: _unref(appointment) }, null, 8, ["item"])
            ], 64))
          : _createCommentVNode("", true)
    ]),
    (
      !_unref(isPending) &&
      _unref(appointment) &&
      _unref(appointment).status !== 'cancelado' &&
      _unref(appointment).status !== 'concluido' &&
      _unref(appointment).status !== 'recusado'
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Actions, { item: _unref(appointment) }, null, 8, ["item"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})